<template lang="pug">
  div
    b-loading(:active.sync="validationInProgress")
    h2.has-text-weight-bold {{ $t('Validate your User Master Data file') }}
    p.has-bottom-margin
      |
      | {{ $t('Upon successful validation, you can upload it together with your Dataset(s) in the') }}
      |
      a(@click="$emit('toUploadTab')") Dataset Excel Template
        |
        |
        b-icon(size="is-small" icon="arrow-right")
        |
        | ecoSpold2
      |
      | {{ $t('tab.') }}
      |
      | {{ $t('Validation errors will be sent to the "Error Log" for your immediate attention should they occur.') }}
    .columns
      .column
        b-field.file
          b-upload(v-model="umd" :accept="mimeTypes" :disabled="hasUploadedMasterData")
            a.button(:disabled="hasUploadedMasterData")
              b-icon(icon="upload")
              span {{ $t('Add User Masterdata') }}
      .column.has-text-centered-tablet
        a.button.is-green(v-if="!validationCompleted" :disabled="validationInProgress || !hasUploadedMasterData"
          :class="{ 'is-loading': validationInProgress }" @click="startValidation")
          b-icon(icon="chevron-circle-right")
          span {{ $t('Start Validation') }}
        a.button.is-outlined.is-danger(v-if="validationCompleted && !validationOK" :href="downloadUrl")
          b-icon(icon="download")
          span {{ $t('Download Validation Results') }}
      .column.has-text-right-tablet
        a.button.is-danger(@click="restart" :disabled="validationInProgress || !hasUploadedMasterData")
          b-icon(icon="undo")
          span {{ $t('Restart') }}
    div.has-bottom-margin(v-if="hasErrors")
      error-statistics(:errors="validationErrors")
    div.has-bottom-margin.message.is-green(v-if="validationOK")
      .message-body
        h3.has-text-weight-bold {{ $t('Validation OK') }}
        .content
          p {{ $t('No errors or warning have been found')}}.
            |
            |
            a(@click="$emit('toUploadTab')") {{ $t('Continue to dataset upload') }}.
    div(v-if="hasUploadedMasterData")
      h3.has-text-weight-bold {{ $t('User Masterdata') }}
      ul
        li(v-for="file in umd") {{ file.name }}, {{ fileSize(file.size) }} kB, {{ fileDate(file.lastModified) }}
      p
</template>

<script>
import { validateMasterdata, getUMDValidationTime, CONTENT_TYPE_XLSX } from '../utils/api'
import ConvertDownloadButton from './ConvertDownloadButton'
import ErrorStatistics from './ErrorStatistics'

export default {
  name: 'MasterdataValidation',
  components: {
    ErrorStatistics,
    ConvertDownloadButton
  },
  data() {
    return {
      mimeTypes: CONTENT_TYPE_XLSX,
      downloadUrl: '',
      validationInProgress: false,
      validationCompleted: false,
      validationOK: false,
      validationErrors: {},
      umd: []
    }
  },
  computed: {
    hasUploadedMasterData() {
      return !!this.uploadedMasterData
    },
    uploadedMasterData() {
      return this.umd.length
    },
    hasErrors() {
      return Object.keys(this.validationErrors).length > 0
    }
  },
  methods: {
    fileSize(bytes) {
      return Number.parseInt(bytes / 1024)
    },
    fileDate(seconds) {
      return new Date(seconds).toLocaleString('en-US')
    },
    startValidation() {
      if (this.validationInProgress || !this.hasUploadedMasterData) {
        return
      }
      this.validationInProgress = true
      getUMDValidationTime()
        .then((response) => {
          let expectedTime = Number(response.data.conversion_time__avg * 1000)
          expectedTime = expectedTime.toFixed()
          this.$Progress.start(expectedTime)
        })
      validateMasterdata(this.umd)
        .then(() => {
          this.validationCompleted = true
          this.validationOK = true
          this.$Progress.finish()
        })
        .catch((error) => {
          this.$Progress.fail()
          this.validationCompleted = true
          if (error.response.status === 400) {
            this.validationErrors = error.response.data.errors
            this.downloadUrl = error.response.data.template_file
          } else {
          }
        })
        .finally(() => {
          this.validationInProgress = false
        })
    },
    restart() {
      if (this.validationInProgress) {
        return
      }
      this.umd = []
      this.validationCompleted = false
      this.validationOK = false
      this.validationErrors = []
    }
  }
}
</script>

<style scoped>
  .has-bottom-margin {
    margin-bottom: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/MasterdataValidation.vue